var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsult2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1074.4 2230.3-14.062-2.8125-233.44-36.562v-30.938l-53.438-554.06c-11.25-194.06-177.19-340.31-371.25-329.06s-340.31 177.19-329.06 371.25l53.438 554.06c8.4375 143.44 101.25 261.56 227.81 309.38 30.938 16.875 64.688 25.312 104.06 22.5l461.25 19.688v419.06c0 75.938 59.062 135 135 135s135-59.062 135-135v-610.31c0-67.5-47.812-123.75-115.31-132.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m781.88 826.88c0 183.29-148.59 331.88-331.88 331.88s-331.88-148.59-331.88-331.88 148.59-331.88 331.88-331.88 331.88 148.59 331.88 331.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3197.8 1276.9c-194.06-11.25-360 135-371.25 329.06l-53.438 554.06v30.938l-233.44 36.562-14.062 2.8125c-64.688 11.25-112.5 67.5-112.5 132.19v610.31c0 75.938 59.062 135 135 135s135-59.062 135-135v-421.88l461.25-19.688c36.562 2.8125 73.125-5.625 104.06-22.5 126.56-47.812 219.38-165.94 227.81-309.38l53.438-554.06c8.4375-191.25-137.81-357.19-331.88-368.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3481.9 826.88c0 183.29-148.59 331.88-331.88 331.88s-331.88-148.59-331.88-331.88 148.59-331.88 331.88-331.88 331.88 148.59 331.88 331.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2553.8 1960.3c0-75.938-59.062-135-135-135h-1237.5c-75.938 0-135 59.062-135 135s59.062 135 135 135h146.25v1009.7h945v-1009.7h146.25c73.125 0 135-59.062 135-135z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsult2);
export default __webpack_public_path__ + "static/media/consult2.fa1dd7cad7214f5a2e4374a43cd8ef87.svg";
export { ForwardRef as ReactComponent };